var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppPageContainer',{attrs:{"showNav":true,"clean":true,"background":'calendar'}},[_c('div',{staticClass:"day"},[_c('div',[_vm._v("just what i want to do today")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }